export default __webpack_public_path__ + "static/media/aisafety.8084ab84.jpg";